import React from 'react';
import cx from 'classnames';

import './Tooltip.css';

export interface TooltipProp {
  /**
   * Text content of the tooltip
   */
  text?: string;
  /**
   * Text content of the tooltip, probably should NOT use this
   */
  htmlText?: string; // htmlText is added in because sometimes tooltips require some words to be bold or have specific styling applied
  /**
   * Class name of parent element
   */
  className?: string;
  /**
   * Show/hide the tooltip
   */
  popIn?: boolean;
}

/**
 * @deprecated Use `TooltipV3` instead
 */
const Tooltip = ({ text, htmlText, className, popIn }: TooltipProp): JSX.Element => (
  <div className={cx('zola-ui', 'tooltip__container', className)}>
    <div className={cx('tooltip', { 'pop-in': popIn })}>
      {text}
      {/* eslint-disable-next-line react/no-danger */}
      {htmlText && <span dangerouslySetInnerHTML={{ __html: `${htmlText}` }} />}
    </div>
  </div>
);

export default Tooltip;
